import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../EmptyState';
import { SubscriptionsTierContentType } from '../../../../../types/subscriptionsSection';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { URLS } from '@wix/da-url';
import {
  ModalOptions,
  ModalType,
} from '@wix/da-shared-react/pkg/Modals/redux/types';

import s from './EmptyState.scss';

export type Props = {
  isOwner: boolean;
  profileOwnerUser: PapiUser;
  isDraft?: boolean;
  tierContentType: SubscriptionsTierContentType;
  showSubmitModal?: (type: string, options?: ModalOptions) => void;
};

const TierContentEmptyState: React.FC<Props> = ({
  profileOwnerUser,
  isOwner,
  isDraft,
  tierContentType,
  showSubmitModal,
}) => {
  const { t } = useTranslation();
  const { username } = profileOwnerUser;

  return isOwner ? (
    <EmptyState
      className={s['empty-state']}
      illustration={<div className={s['owner-illustration']} />}
      title={t(`widgets.tierContent.empty.title.owner`)}
      subtitle={t(
        `widgets.tierContent.empty.subtitle.owner${isDraft ? '.draft' : ''}`
      )}
      customButton={
        !isDraft && (
          <SolidButton
            className={s['cta']}
            size="medium"
            variant="approval-green"
            priority="primary"
            onClick={() => {
              if (tierContentType === SubscriptionsTierContentType.DEVIATIONS) {
                window.location.assign(URLS.SUBMIT);
                return;
              }
              showSubmitModal && showSubmitModal(ModalType.STATUS_UPDATE);
            }}
          >
            {t(`widgets.tierContent.empty.cta.${tierContentType}`)}
          </SolidButton>
        )
      }
    />
  ) : (
    <EmptyState
      className={s['empty-state']}
      illustration={<div className={s['illustration']} />}
      title={t(`widgets.tierContent.empty.title.visitor`, {
        username,
      })}
      subtitle={t(`widgets.tierContent.empty.subtitle.visitor`, {
        username,
      })}
    />
  );
};

TierContentEmptyState.displayName = 'TierContentEmptyState';

export default TierContentEmptyState;
